// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { BidPackageDetailActiveRequestFragmentDoc } from '../../routes/bids/BidPackageDetailPage.generated';
import { DisplayNamedFragmentDoc } from '../../fragments/commonFragments.generated';
import { PlanBasedBidsTable_TakeoffLineItemVersionFragmentDoc } from '../../routes/bids/components/PlanBasedBidsTable.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BidContractPlanPricing_RevisionQueryVariables = Types.Exact<{
  bidContractRevisionId: Types.Scalars['ID']['input'];
}>;


export type BidContractPlanPricing_RevisionQuery = { __typename?: 'Query', bidContractRevision: { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, isInternalEstimate: boolean, name: string, type?: { __typename?: 'BidContractTypeDetail', code: Types.BidContractType } | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, bidRequest?: { __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, bidContract?: { __typename?: 'BidContract', id: string } | null | undefined } | null | undefined }, tradeLineItems: Array<{ __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?:
          | { __typename?: 'ItemTemplateItemVersion', id: string }
          | { __typename?: 'ItemTemplateItem', id: string }
          | { __typename?: 'TakeoffLineItem', id: string }
          | { __typename?: 'TakeoffLineItemVersion', id: string }
         | null | undefined }> }>, bidPackageVersion?: { __typename?: 'BidPackageVersion', id: string, readyPlanAggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, displayName: string, readyPlan:
          | { __typename?: 'ReadyPlan', id: string }
          | { __typename?: 'PlanPackage', id: string }
          | { __typename?: 'DesignPackage', id: string }
          | { __typename?: 'ProductOffering', id: string }
         }> } | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean } } };

export type BidContractPlanPricing_RevisionFragment = { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, isInternalEstimate: boolean, name: string, type?: { __typename?: 'BidContractTypeDetail', code: Types.BidContractType } | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, bidRequest?: { __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, bidContract?: { __typename?: 'BidContract', id: string } | null | undefined } | null | undefined }, tradeLineItems: Array<{ __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?:
        | { __typename?: 'ItemTemplateItemVersion', id: string }
        | { __typename?: 'ItemTemplateItem', id: string }
        | { __typename?: 'TakeoffLineItem', id: string }
        | { __typename?: 'TakeoffLineItemVersion', id: string }
       | null | undefined }> }>, bidPackageVersion?: { __typename?: 'BidPackageVersion', id: string, readyPlanAggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, displayName: string, readyPlan:
        | { __typename?: 'ReadyPlan', id: string }
        | { __typename?: 'PlanPackage', id: string }
        | { __typename?: 'DesignPackage', id: string }
        | { __typename?: 'ProductOffering', id: string }
       }> } | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean } };

export type BidContractPlanPricing_ScopeLinesQueryVariables = Types.Exact<{
  bidPackageVersionId: Types.Scalars['ID']['input'];
  filter: Types.BpvScopeLinesFilter;
}>;


export type BidContractPlanPricing_ScopeLinesQuery = { __typename?: 'Query', bidPackageVersionScopeLines: Array<{ __typename?: 'BidPackageScopeLine', takeoffLineItemVersion: { __typename?: 'TakeoffLineItemVersion', quantity?: number | null | undefined, id: string, name: string, identity: { __typename?: 'TakeoffLineItem', id: string }, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string, number: string, name: string } }, bidItem?: { __typename?: 'BidItem', id: string, parentMaterialVariant?: { __typename?: 'MaterialVariant', id: string, code: string } | null | undefined } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, shortName: string, useQuantity: boolean }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, parent:
        | { __typename?: 'ReadyPlan', id: string, displayName: string }
        | { __typename?: 'PlanPackage', id: string, displayName: string }
        | { __typename?: 'DesignPackage', id: string, displayName: string }
        | { __typename?: 'ProductOffering', id: string, displayName: string }
      , readyPlan:
        | { __typename?: 'ReadyPlan', id: string, name: string }
        | { __typename?: 'PlanPackage', id: string, name: string }
        | { __typename?: 'DesignPackage', id: string, name: string }
        | { __typename?: 'ProductOffering', id: string, name: string }
      , options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string }, globalOption: { __typename?: 'GlobalOption', id: string }, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, groupByFeature: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }>, laborLine?: { __typename?: 'TakeoffLineItem', id: string } | null | undefined, costEstimate: { __typename?: 'CostEstimate', costInCents: number }, drop?: { __typename?: 'Drop', id: string, code: string, name: string } | null | undefined } }> };

export type BidContractPlanPricingTradeLineItemFragment = { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?:
      | { __typename?: 'ItemTemplateItemVersion', id: string }
      | { __typename?: 'ItemTemplateItem', id: string }
      | { __typename?: 'TakeoffLineItem', id: string }
      | { __typename?: 'TakeoffLineItemVersion', id: string }
     | null | undefined }> };

export const BidContractPlanPricingTradeLineItemFragmentDoc = gql`
    fragment BidContractPlanPricingTradeLineItem on BidContractTradeLineItem {
  id
  totalCostInCents
  productOffering {
    id
  }
  options {
    id
  }
  lineItems {
    id
    totalCostInCents
    itemTemplateItem {
      id
    }
  }
}
    `;
export const BidContractPlanPricing_RevisionFragmentDoc = gql`
    fragment BidContractPlanPricing_Revision on BidContractRevision {
  id
  bidContract {
    id
    isInternalEstimate
    name
    type {
      code
    }
    tradePartner {
      id
      name
    }
    bidRequest {
      ...BidPackageDetailActiveRequest
    }
  }
  tradeLineItems {
    ...BidContractPlanPricingTradeLineItem
  }
  bidPackageVersion {
    id
    readyPlanAggregateVersions {
      ...DisplayNamed
      readyPlan {
        id
      }
    }
  }
  canEdit {
    allowed
  }
}
    ${BidPackageDetailActiveRequestFragmentDoc}
${BidContractPlanPricingTradeLineItemFragmentDoc}
${DisplayNamedFragmentDoc}`;
export const BidContractPlanPricing_RevisionDocument = gql`
    query BidContractPlanPricing_Revision($bidContractRevisionId: ID!) {
  bidContractRevision(id: $bidContractRevisionId) {
    ...BidContractPlanPricing_Revision
  }
}
    ${BidContractPlanPricing_RevisionFragmentDoc}`;

/**
 * __useBidContractPlanPricing_RevisionQuery__
 *
 * To run a query within a React component, call `useBidContractPlanPricing_RevisionQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidContractPlanPricing_RevisionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidContractPlanPricing_RevisionQuery({
 *   variables: {
 *      bidContractRevisionId: // value for 'bidContractRevisionId'
 *   },
 * });
 */
export function useBidContractPlanPricing_RevisionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidContractPlanPricing_RevisionQuery, BidContractPlanPricing_RevisionQueryVariables> & ({ variables: BidContractPlanPricing_RevisionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidContractPlanPricing_RevisionQuery, BidContractPlanPricing_RevisionQueryVariables>(BidContractPlanPricing_RevisionDocument, options);
      }
export function useBidContractPlanPricing_RevisionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidContractPlanPricing_RevisionQuery, BidContractPlanPricing_RevisionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidContractPlanPricing_RevisionQuery, BidContractPlanPricing_RevisionQueryVariables>(BidContractPlanPricing_RevisionDocument, options);
        }
// @ts-ignore
export function useBidContractPlanPricing_RevisionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidContractPlanPricing_RevisionQuery, BidContractPlanPricing_RevisionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidContractPlanPricing_RevisionQuery, BidContractPlanPricing_RevisionQueryVariables>;
export function useBidContractPlanPricing_RevisionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractPlanPricing_RevisionQuery, BidContractPlanPricing_RevisionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidContractPlanPricing_RevisionQuery | undefined, BidContractPlanPricing_RevisionQueryVariables>;
export function useBidContractPlanPricing_RevisionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractPlanPricing_RevisionQuery, BidContractPlanPricing_RevisionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidContractPlanPricing_RevisionQuery, BidContractPlanPricing_RevisionQueryVariables>(BidContractPlanPricing_RevisionDocument, options);
        }
export type BidContractPlanPricing_RevisionQueryHookResult = ReturnType<typeof useBidContractPlanPricing_RevisionQuery>;
export type BidContractPlanPricing_RevisionLazyQueryHookResult = ReturnType<typeof useBidContractPlanPricing_RevisionLazyQuery>;
export type BidContractPlanPricing_RevisionSuspenseQueryHookResult = ReturnType<typeof useBidContractPlanPricing_RevisionSuspenseQuery>;
export type BidContractPlanPricing_RevisionQueryResult = Apollo.QueryResult<BidContractPlanPricing_RevisionQuery, BidContractPlanPricing_RevisionQueryVariables>;
export const BidContractPlanPricing_ScopeLinesDocument = gql`
    query BidContractPlanPricing_ScopeLines($bidPackageVersionId: ID!, $filter: BPVScopeLinesFilter!) {
  bidPackageVersionScopeLines(id: $bidPackageVersionId, filter: $filter) {
    takeoffLineItemVersion {
      ...PlanBasedBidsTable_TakeoffLineItemVersion
    }
  }
}
    ${PlanBasedBidsTable_TakeoffLineItemVersionFragmentDoc}`;

/**
 * __useBidContractPlanPricing_ScopeLinesQuery__
 *
 * To run a query within a React component, call `useBidContractPlanPricing_ScopeLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidContractPlanPricing_ScopeLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidContractPlanPricing_ScopeLinesQuery({
 *   variables: {
 *      bidPackageVersionId: // value for 'bidPackageVersionId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBidContractPlanPricing_ScopeLinesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidContractPlanPricing_ScopeLinesQuery, BidContractPlanPricing_ScopeLinesQueryVariables> & ({ variables: BidContractPlanPricing_ScopeLinesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidContractPlanPricing_ScopeLinesQuery, BidContractPlanPricing_ScopeLinesQueryVariables>(BidContractPlanPricing_ScopeLinesDocument, options);
      }
export function useBidContractPlanPricing_ScopeLinesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidContractPlanPricing_ScopeLinesQuery, BidContractPlanPricing_ScopeLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidContractPlanPricing_ScopeLinesQuery, BidContractPlanPricing_ScopeLinesQueryVariables>(BidContractPlanPricing_ScopeLinesDocument, options);
        }
// @ts-ignore
export function useBidContractPlanPricing_ScopeLinesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidContractPlanPricing_ScopeLinesQuery, BidContractPlanPricing_ScopeLinesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidContractPlanPricing_ScopeLinesQuery, BidContractPlanPricing_ScopeLinesQueryVariables>;
export function useBidContractPlanPricing_ScopeLinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractPlanPricing_ScopeLinesQuery, BidContractPlanPricing_ScopeLinesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidContractPlanPricing_ScopeLinesQuery | undefined, BidContractPlanPricing_ScopeLinesQueryVariables>;
export function useBidContractPlanPricing_ScopeLinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractPlanPricing_ScopeLinesQuery, BidContractPlanPricing_ScopeLinesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidContractPlanPricing_ScopeLinesQuery, BidContractPlanPricing_ScopeLinesQueryVariables>(BidContractPlanPricing_ScopeLinesDocument, options);
        }
export type BidContractPlanPricing_ScopeLinesQueryHookResult = ReturnType<typeof useBidContractPlanPricing_ScopeLinesQuery>;
export type BidContractPlanPricing_ScopeLinesLazyQueryHookResult = ReturnType<typeof useBidContractPlanPricing_ScopeLinesLazyQuery>;
export type BidContractPlanPricing_ScopeLinesSuspenseQueryHookResult = ReturnType<typeof useBidContractPlanPricing_ScopeLinesSuspenseQuery>;
export type BidContractPlanPricing_ScopeLinesQueryResult = Apollo.QueryResult<BidContractPlanPricing_ScopeLinesQuery, BidContractPlanPricing_ScopeLinesQueryVariables>;